export default __webpack_public_path__ + "static/media/caret-right.e0af90ee.svg";